<section class="container mb-20">
  <ng-container *transloco="let t; prefix: 'financing.top-section'">
    <div class="max-w-[794px] mx-auto mt-12">
      <h2 class="text-center text-black rfs:text-5xl mb-6">
        {{ t("title") }}
      </h2>
      <p class="text-center text-gray-800 mt-6">
        {{ t("text") }}
      </p>
    </div>
    <section class="w-full mt-12 flex items-center justify-center">
      <div imageScrollAnimation style="transform: scale(0.7)"
        class="justify-self-center w-[358px] h-[222px] md:w-[864px] md:h-[346px] bg-[url('./assets/financing/test-scroll.png')] bg-no-repeat bg-cover rounded-md">
      </div>
    </section>
  </ng-container>
</section>
<section class="container mb-20">
  <ng-container *transloco="let t; prefix: 'financing.info-section'">
    <div class="max-w-[800px] mx-auto mt-28">
      <h4 class="text-center text-black rfs:text-3xl mb-8">
        {{ t("title.part01") }}
        <span class="text-[#059B9C]">{{ t("title.part02") }}</span>.
      </h4>
      <p class="text-center rfs:text-xl">
        {{ t("text") }}
      </p>
    </div>
  </ng-container>
</section>
<section class="container mb-20">
  <app-select-loan></app-select-loan>
</section>

<section class="container mb-20">
  <ng-container *transloco="let t; prefix: 'financing.calculator-section'">
    <div class="bg-white rounded-[1rem] py-20 md:px-12 lg:bg-[url(./assets/img/corner-gray.png)] bg-no-repeat"
      style="background-position-x: 98%; background-position-y: 3%">
      <div class="p-6 lg:p-0">
        <div class="mb-10">
          <h3 class="text-black rfs:text-4xl mb-10">
            {{ t("title") }}
          </h3>
          <p class="text-gray-900">
            {{ t("text") }}
          </p>
        </div>
        <div class="mb-6">
          <form>
            <div class="flex lg:flex-row flex-col justify-between gap-12">
              <app-loan-calulator [isFinancing]="true" [propertyValueUiDisabled]="true"
                class="flex-1"></app-loan-calulator>
              <div>
                <app-doughnut-chart [showEstimatedFees]="false"></app-doughnut-chart>
                <div class="my-6 text-gray-700 font-semibold flex flex-row justify-center gap-2 text-xs">
                  {{ t("fulfilledby") }}
                  <span>
                    <img src="{{'assets/svgs/nbg-logo-black' + (activeLang === 'en' ? '-en': '') +'.svg'}}"
                      alt="NBG Logo" />
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="flex flex-col md:flex-row gap-6">
          <button class="btn-primary" (click)="askFinancialServices('/loan-application')">
            {{ t("button01") }}
          </button>
          <button class="btn-secondary" (click)="askFinancialServices('/loan-eligibility')">
            {{ t("button02") }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</section>

<section class="container mb-20">
  <app-reasons-to-choose-financing></app-reasons-to-choose-financing>
</section>

<section class="container mb-20">
  <app-financing-stepper></app-financing-stepper>
</section>

<section class="container mb-20">
  <app-financing-actions></app-financing-actions>
</section>